export enum SHARES_MODAL_MODE {
	NEW_JOINERS,
	ADD_ALLOCATION,
}

export const POLL_FOR_UPDATE_PROGRESS_IN_MS = 1000;
export const INVESTOR_EMAIL_WORKFLOW_HANDLER_STORAGE_KEY =
	'INVESTOR_EMAIL_WORKFLOW_HANDLER_STORAGE_KEY';
export const INVESTOR_RELEASE_WORKFLOW_HANDLER_STORAGE_KEY =
	'INVESTOR_RELEASE_WORKFLOW_HANDLER_STORAGE_KEY';

export enum MIP_INVESTOR_INVITATION_FORM {
	CUSTOM_INVITATION_TEXT_AREA = 'custom_text_field',
}

export const SHOW_MIP_MANAGE_CONGRATULATION_MODAL = 'SHOW_MIP_MANAGE_CONGRATULATION_MODAL_{mipId}';
